import { CaseGranulometry } from '../../../CaseGranulometry';
import { getTopLevelLodgmentSectionsCount } from '../../../../levels/queries/topLevels/counts/getTopLevelLodgmentSectionsCount';
import { getCaseTopLevels } from '../../levels/getCaseTopLevels';

export const getCaseMaxLodgmentSectionsCountInTopLevels = (
  caseGranulometry: CaseGranulometry
): number => Math.max(...getCaseTopLevels(caseGranulometry).map(getTopLevelLodgmentSectionsCount));
